import { JSX } from "react";

import { STACK_PULL_REQUESTS_COLUMN_ID } from "../../constants";
import { StackPullRequestsTablePullRequestCellProps } from "../types";
import StackPullRequestsTablePullRequestActionsCell from "./ActionsCell";
import StackPullRequestsTablePullRequestAuthorCell from "./AuthorCell";
import StackPullRequestsTablePullRequestBranchCell from "./BranchCell";
import StackPullRequestsTablePullRequestDeltaCell from "./DeltaCell";
import StackPullRequestsTablePullRequestOpenedAtCell from "./OpenedAtCell";
import StackPullRequestsTablePullRequestPrCell from "./PrCell";
import StackPullRequestsTablePullRequestStatusCell from "./StatusCell";
import StackPullRequestsTablePullRequestTitleCell from "./TitleCell";

export const STACK_PULL_REQUESTS_PULL_REQUEST_CELLS: Record<
  string,
  (props: StackPullRequestsTablePullRequestCellProps) => JSX.Element
> = {
  [STACK_PULL_REQUESTS_COLUMN_ID.STATUS]: StackPullRequestsTablePullRequestStatusCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.TITLE]: StackPullRequestsTablePullRequestTitleCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.AUTHOR]: StackPullRequestsTablePullRequestAuthorCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.PR]: StackPullRequestsTablePullRequestPrCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.BRANCH]: StackPullRequestsTablePullRequestBranchCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.DELTA]: StackPullRequestsTablePullRequestDeltaCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.CREATED_AT]: StackPullRequestsTablePullRequestOpenedAtCell,
  [STACK_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS]: StackPullRequestsTablePullRequestActionsCell,
};
